import { sanitizeAicopyBehaviorEvent } from "@/utils/clientBehavior/aicopyModelTier";
import { patchAppWebViewEventContext } from "@/utils/resolveAppWebViewBehaviorContext";
import {
  ensureSiteClientCode,
  syncQueueEventClientCode,
} from "@/utils/behaviorClientCode";

export const BEHAVIOR_TRACKER_QUEUE_KEY = "__behavior_tracker_queue__";

/** 后端 spec 未登记、需从队列 properties 剔除的字段 */
const UNSUPPORTED_PROPERTY_KEYS = ["from_market_type"];

function sanitizeUnsupportedEventProperties(event) {
  if (!event?.properties || !UNSUPPORTED_PROPERTY_KEYS.length) return event;
  let removed = false;
  const properties = { ...event.properties };
  UNSUPPORTED_PROPERTY_KEYS.forEach((key) => {
    if (key in properties) {
      delete properties[key];
      removed = true;
    }
  });
  return removed ? { ...event, properties } : event;
}

function readQueueFromStorage() {
  if (typeof window === "undefined" || !window.localStorage) return [];
  return JSON.parse(window.localStorage.getItem(BEHAVIOR_TRACKER_QUEUE_KEY) || "[]");
}

function writeQueueToStorage(queue) {
  if (typeof window === "undefined" || !window.localStorage) return;
  window.localStorage.setItem(BEHAVIOR_TRACKER_QUEUE_KEY, JSON.stringify(queue));
}

/**
 * 清洗离线队列：非法字段、App context、client_code 与 Cookie 对齐。
 * @returns {boolean} 是否有变更
 */
export function sanitizeBehaviorTrackerQueue() {
  const queue = readQueueFromStorage();
  if (!Array.isArray(queue) || !queue.length) return false;

  const siteClientCode = ensureSiteClientCode();
  const next = [];
  let changed = false;

  for (const event of queue) {
    let cleaned = sanitizeAicopyBehaviorEvent(event);
    if (!cleaned) {
      changed = true;
      continue;
    }
    cleaned = patchAppWebViewEventContext(cleaned);
    if (!cleaned) {
      changed = true;
      continue;
    }
    cleaned = sanitizeUnsupportedEventProperties(cleaned);
    const synced = syncQueueEventClientCode(cleaned, siteClientCode);
    if (synced !== event) changed = true;
    next.push(synced);
  }

  if (changed) {
    writeQueueToStorage(next);
  }
  return changed;
}
